import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, Typography, Container } from "@mui/material";

function OpenSource() {
    const [opensource, setOpensource] = useState([]);

    useEffect(() => {
        axios({
            method: "GET",
            url: "/files/webApplication/open_source.txt",
        }).then((res) => {
            setOpensource(res.data);
        });
    }, []);

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            <Box id="opensource" sx={{ mt: 8, mb: 6 }}>
                {/* Title */}
                <Typography
                    variant="h3"
                    align="center"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: "#030366",
                        mt: 7,
                        fontSize: {
                            xs: "1.8rem",  // mobile (~h4)
                            sm: "2.2rem",  // tablet (~h3)
                            md: "2.8rem",  // laptop (~h3+)
                            lg: "3rem",    // desktop (~h2)
                        },
                    }}
                >
                    Open Source Development
                </Typography>

                {/* Content */}
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", mt: 4 }}>
                    {opensource &&
                        opensource.map((data, index) => (
                            <Typography
                                key={index}
                                variant="body1"
                                sx={{
                                    fontFamily: "Raleway, sans-serif",
                                    textAlign: "justify",
                                    mb: 2,
                                }}
                            >
                                {Array.isArray(data) ? data.join(", ") : data}
                            </Typography>
                        ))}
                </Box>
            </Box>
        </Container>
    );
}

export default OpenSource;
